/**
 * @generated SignedSource<<193afe3edebf9b23d8d9084f6c5830f3>>
 * @relayHash dc72ca00e2d1457e65f0598584181ac4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4c301260df5a4466153ed3f56d8be0b24166ae188507e59c4709e8a0159d8500

import type { ConcreteRequest } from 'relay-runtime';
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type useAnalyticsByLineQuery$variables = {
  contentId: string;
  fromDate?: string | null | undefined;
};
export type useAnalyticsByLineQuery$data = {
  readonly contentAnalyticsViewers: {
    readonly count: number;
  } | null | undefined;
  readonly user: {
    readonly confluence: {
      readonly permissionType: SitePermissionType | null | undefined;
    } | null | undefined;
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type useAnalyticsByLineQuery = {
  response: useAnalyticsByLineQuery$data;
  variables: useAnalyticsByLineQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fromDate"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "fromDate",
        "variableName": "fromDate"
      }
    ],
    "concreteType": "ContentAnalyticsViewers",
    "kind": "LinkedField",
    "name": "contentAnalyticsViewers",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "count"
      }
    ]
  },
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": true
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "concreteType": "ConfluenceUser",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "permissionType"
          }
        ]
      }
    ],
    "storageKey": "confluence_atlassianUser(current:true)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useAnalyticsByLineQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAnalyticsByLineQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "dc72ca00e2d1457e65f0598584181ac4",
    "id": "4c301260df5a4466153ed3f56d8be0b24166ae188507e59c4709e8a0159d8500",
    "metadata": {},
    "name": "useAnalyticsByLineQuery",
    "operationKind": "query",
    "text": "query useAnalyticsByLineQuery($contentId:ID!,$fromDate:String){contentAnalyticsViewers(contentId:$contentId,fromDate:$fromDate){count},user:confluence_atlassianUser(current:true){id,confluence{permissionType}}}"
  }
};
})();

(node as any).hash = "bc547488b58318aeb15d566ad5044ad7";

export default node;
